import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { GetProfileAvatarUrl } from "src/graphql/users";

export const useProfileAvatar = ({ pause } = {}) => {
  const uid = useSelector((state) => state.auth.uid);
  const isPaused = pause ?? !uid;

  const {
    data: profileAvatarData,
    executeQuery: refetchProfileAvatarUrl,
  } = GetProfileAvatarUrl({ pause: isPaused });

  const profileAvatarUrl = profileAvatarData?.profileAvatarUrl?.url || null;

  useEffect(() => {
    if (isPaused) return;
    refetchProfileAvatarUrl({ requestPolicy: "network-only" });
  }, [isPaused, refetchProfileAvatarUrl]);

  const onUploadSuccess = useCallback(() => {
    refetchProfileAvatarUrl({ requestPolicy: "network-only" });
  }, [refetchProfileAvatarUrl]);

  return {
    profileAvatarUrl,
    refetchProfileAvatarUrl,
    onUploadSuccess,
  };
};
